import { combineReducers } from 'redux';
import routing from './routing';
import claimentDetails from './claimentDetails';
import deceasedDetails from './deceasedDetails';
import uploadDocuments from './uploadDocuments';
import referenceData from './referenceData';

export const sizotsaFuneralClaim = combineReducers({ routing,claimentDetails,deceasedDetails ,uploadDocuments,referenceData});
